import React, { Component } from 'react'

export default class Robot extends Component {
  render() {
    return (
      <div>
				<section className="colorlib-work" data-section="projects">
				<div className="colorlib-narrow-content">
						<div className="row">
							<div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
								<span className="heading-meta">Robot</span>
								<h2 className="colorlib-heading animate-box">Robot Framework</h2>
							</div>
						</div>
						{/* https://hugovk.github.io/top-pypi-packages/top-pypi-packages-30-days.json */ }
						<p>Robot Framework is pretty popular framework. Statistics of last 30 days. (Robot framework and library installations with pip <a href="top-pypi-packages-30-days.json">source</a>)</p>
				</div>
				
				<div id="colorlib-counter" className="colorlib-counters" style={{backgroundImage: 'url(images/gears.jpg)'}} data-stellar-background-ratio="0.5">
				
				<div className="overlay"></div>
				<div className="colorlib-narrow-content">
					<div className="row">
					</div>
					<div className="row" >

						<div className="col-md-3 text-center animate-box">
							<span className="colorlib-counter js-counter" data-from="0" data-to="436392" data-speed="5000" data-refresh-interval="50"></span>
							<span className="colorlib-counter-label"><strong>Robotframework installations</strong></span>
						</div>
						<div className="col-md-3 text-center animate-box">
							<span className="colorlib-counter js-counter" data-from="0" data-to="201824" data-speed="5000" data-refresh-interval="50"></span>
							<span className="colorlib-counter-label"><strong>robotframework-seleniumlibrary</strong></span>
						</div>
						<div className="col-md-3 text-center animate-box">
							<span className="colorlib-counter js-counter" data-from="0" data-to="136380" data-speed="5000" data-refresh-interval="50"></span>
							<span className="colorlib-counter-label"><strong>robotframework-requests</strong></span>
						</div>
						<div className="col-md-3 text-center animate-box">
							<span className="colorlib-counter js-counter" data-from="0" data-to="114716" data-speed="5000" data-refresh-interval="50"></span>
							<span className="colorlib-counter-label"><strong>robotframework-selenium2library</strong></span>
						</div>
					</div>
				</div>
			</div>
			<div className="colorlib-narrow-content">
			<p>Check my more detailed Robot Framework <a href="https://saaristoantti.github.io/robot/">page</a></p>
			</div>
				{ /* 1
					<div className="colorlib-narrow-content">
						<div className="row">
							<div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
								<span className="heading-meta">Robot</span>
								<h2 className="colorlib-heading animate-box">Robot Framework</h2>
							</div>
						</div>
						<div className="row">
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<div className="project" style={{backgroundImage: 'url(images/img-1.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="https://saaristoantti.github.io/robot/" target="_self"> installation</a></h3>
											<span>How to setup robot?</span>
										</div>
									</div>
								</div>
				</div> */ }
							{ /* 2
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-2.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 02</a></h3>
											<span>Animation</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							*/}

							{ /* 3 -->
							<div className="col-md-4 animate-box" data-animate-effect="fadeInTop">
								<div className="project" style={{backgroundImage: 'url(images/img-3.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 03</a></h3>
											<span>Illustration</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							*/}

							{ /* ---> 4
							<div className="col-md-4 animate-box" data-animate-effect="fadeInBottom">
								<div className="project" style={{backgroundImage: 'url(images/img-4.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 04</a></h3>
											<span>Application</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							*/ }
							{ /* ---> 5
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<div className="project" style={{backgroundImage: 'url(images/img-5.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 05</a></h3>
											<span>Graphic, Logo</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							*/ }
							{ /* ---> 6
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 06</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div> */ }
							{ /* </div> */ }
							{ /*
						<div className="row">
							<div className="col-md-12 animate-box">
								<p><a href="#" className="btn btn-primary btn-lg btn-load-more">Coming soon ... <i className="icon-reload" /></a></p>
							</div>
						</div>
							*/ }
					{ /*</div> */ }
				</section>
      </div>
    )
  }
}
